/**
 * Shared loading indicator so tabs present a consistent "loading" state.
 * @param {{ message?: string }} props
 */
export default function Loading({ message = 'Loading…' }) {
  return (
    <div className="loading" role="status" aria-live="polite">
      {message}
    </div>
  );
}
